/**
 * Copyright (c) 2019-2020 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { IntAdjacencyGraph } from '../../../../mol-math/graph';
import { FormatPropertyProvider } from '../../common/property';

function getGraph(indexA, indexB, props, count) {
  var builder = new IntAdjacencyGraph.EdgeBuilder(count, indexA, indexB);
  var order = new Int8Array(builder.slotCount);
  var distance = new Array(builder.slotCount);
  var flag = new Array(builder.slotCount);

  for (var i = 0, _i = builder.edgeCount; i < _i; i++) {
    builder.addNextEdge();
    builder.assignProperty(order, props.order ? props.order[i] : 1);
    builder.assignProperty(distance, props.distance ? props.distance[i] : -1);
    builder.assignProperty(flag, props.flag ? props.flag[i] : 1
    /* Covalent */
    );
  }

  return builder.createGraph({
    order: order,
    distance: distance,
    flag: flag
  });
}

export var IndexPairBonds;

(function (IndexPairBonds) {
  IndexPairBonds.Descriptor = {
    name: 'index_pair_bonds'
  };
  IndexPairBonds.Provider = FormatPropertyProvider.create(IndexPairBonds.Descriptor);

  function fromData(data) {
    var pairs = data.pairs,
        count = data.count;
    var indexA = pairs.indexA.toArray();
    var indexB = pairs.indexB.toArray();
    var order = pairs.order && pairs.order.toArray();
    var distance = pairs.distance && pairs.distance.toArray();
    var flag = pairs.flag && pairs.flag.toArray();
    return getGraph(indexA, indexB, {
      order: order,
      distance: distance,
      flag: flag
    }, count);
  }

  IndexPairBonds.fromData = fromData;
})(IndexPairBonds || (IndexPairBonds = {}));